import React, {useEffect, useState} from 'react';
import {Button, Col, Row} from 'antd';
import {RealtimeGetMethod} from '../common/ApiMethod';
import {Arguments} from '../common/Arguments';
import {handleExport} from '../common/ExportDataToExcelComponent';

const Researchers = () => {
	const getApi = Arguments.host + '/society_organization/society/api!researcherInformation.do';
	const researcherApi = Arguments.host + '/society_organization/home/api!organizationAndResearch.do';
	const [data, setData] = useState([]);

	useEffect(() => {
		RealtimeGetMethod(researcherApi).then(allData => setData(allData));
	}, [getApi]);

	const exportMethod = () => {
		RealtimeGetMethod(researcherApi).then(allData => {
			const filteredData = allData?.map(
				(
					{
						organization_name,
						people_name,
						people_sex,
						people_born,
						people_zzmm,
						people_education,
						people_research,
						mbsk_post,
						people_is_part,
						people_unit,
						people_post,
						people_professional,
					},
				) =>
					(
						{
							'组织名称': organization_name,
							'姓名': people_name,
							'性别': people_sex,
							'出生日期': people_born,
							'政治面貌': people_zzmm,
							'学历': people_education,
							'研究领域': people_research,
							'社团职务': mbsk_post,
							'是否兼职': people_is_part,
							'工作单位': people_unit,
							'职务': people_post,
							'职称': people_professional,
						}
					),
			);
			handleExport(filteredData);
		});
	};

	return (
		<Row>
			<Col span={3} style={{
				textAlign: 'right',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end',
			}}>民非研究人员：</Col>
			<Col span={1} style={{
				textAlign: 'left',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end',
			}}>{data?.length}</Col>
			<Col span={20} style={{textAlign: 'left'}}>
				<Button type="link" onClick={() => exportMethod()}>【导出】</Button>
			</Col>
		</Row>
	);
};

export default Researchers;
